exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".validation-banner-container {\n  background: rgba(240, 81, 81, 0.1);\n  border: 1px solid rgba(235, 50, 50, 0.5);\n  padding: 5px 10px;\n  color: #9b1432;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n.validation-banner-container .list {\n  margin-top: 5px !important;\n}\n.validation-banner-container ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 !important;\n}\n.validation-banner-container li {\n  padding-left: 4em !important;\n}\n.validation-banner-container li::before {\n  content: '\\2022   ';\n  color: #9b1432 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/validation-banner.less
// module id = 2598
// module chunks = 0